import { render } from "./spinnerContainer.vue?vue&type=template&id=19b90963&scoped=true&ts=true"
import script from "./spinnerContainer.vue?vue&type=script&lang=ts"
export * from "./spinnerContainer.vue?vue&type=script&lang=ts"

import "./spinnerContainer.vue?vue&type=style&index=0&id=19b90963&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b90963"]])

export default __exports__